export const ValidateForm = (data) => {
  const errors = {};

  if (!data.beneficiaryName) {
    errors.beneficiaryName = "Beneficiary Name is required";
  }
  if (!data.printName) {
    errors.printName = "Printed Name is Required";
  }

  // if (!data.medicareNumber) {
  //   errors.medicareNumber = "Medicare Number is required";
  // } else
  if (data.medicareNumber.length > 0 && data.medicareNumber.length < 11) {
    errors.medicareNumber = "Medicare Number must be 11 characters";
  }

 // Date of Birth - Optional
  // If entered, format must be MM/DD/YYYY
  if (
    data.dateOfBirth &&
    !/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/.test(
      data.dateOfBirth
    )
  ) {
    errors.dateOfBirth =
      "Date of Birth must be MM/DD/YYYY";
  }

  // Validate actual DOB and prevent future dates
  if (data.dateOfBirth && !errors.dateOfBirth) {
    const [month, day, year] = data.dateOfBirth
      .split("/")
      .map(Number);

    const dob = new Date(year, month - 1, day);

    // Check invalid dates such as 02/31/1994
    const isValidDate =
      dob.getFullYear() === year &&
      dob.getMonth() === month - 1 &&
      dob.getDate() === day;

    if (!isValidDate) {
      errors.dateOfBirth =
        "Please enter a valid Date of Birth";
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (dob > today) {
        errors.dateOfBirth =
          "Date of Birth cannot be a future date";
      }
    }
  }

// SSN is optional, but if entered it must be XXX-XX-XXXX
if (
  data.socialSecurityNumber &&
  !/^\d{3}-\d{2}-\d{4}$/.test(data.socialSecurityNumber)
) {
  errors.socialSecurityNumber ="Social Security Number must contain only numbers and be in XXX-XX-XXXX format";
  }

  return errors;
};
